import type { AgreementStatus } from './contractsMirror.js';

/**
 * Typed search params for the `/service-agreements` route. The status filter lives in the URL so it
 * is deep-linkable AND compile-checked (the estimates/jobs `searchParams` pattern). TanStack Router
 * validates the raw URL params through `validateServiceAgreementsSearch` on every navigation.
 *
 * `?status=<AgreementStatus>` filters the list to one status (the status-filter pills NAVIGATE with
 * this). The coarse endpoint (22-12) owns the filtering + the counts; the SPA only carries the flag.
 */

const FILTERABLE_STATUSES: readonly AgreementStatus[] = ['active', 'paused', 'cancelled'];

export interface ServiceAgreementsSearch {
  status?: AgreementStatus;
}

/** Coerce a raw URL value into a known `AgreementStatus`, else undefined. */
function asStatus(value: unknown): AgreementStatus | undefined {
  return FILTERABLE_STATUSES.find((s) => s === value);
}

/**
 * TanStack Router `validateSearch` for the service-agreements list route. Keeps the status filter
 * only when it is a known status so the canonical URL stays clean (`/service-agreements` vs
 * `/service-agreements?status=paused`).
 */
export function validateServiceAgreementsSearch(
  raw: Record<string, unknown>,
): ServiceAgreementsSearch {
  const search: ServiceAgreementsSearch = {};
  const status = asStatus(raw.status);
  if (status) search.status = status;
  return search;
}
